import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'

import HomeView from '../views/HomeView'
import UsersView from '../views/UsersView'
import UserAddForm from '../forms/UserAddForm'
import UserEditForm from '../forms/UserEditForm'
import UserDetailsView from '../views/UserDetailsView'
import NotFoundView from '../views/NotFoundView'

//MTO VACWAY
import AccessibilityView from '../views/AccessibilityView'
import PaymentView from '../views/PaymentView'
import PhoneView from '../views/PhoneView'
import TicketView from '../views/TicketView'
import PaymentError from '../views/PaymentError'
import LockerSelectorView from '../views/LockerSelectorView'
import ZoneSelectorView from '../views/ZoneSelectorView'

//OTO VACWAY
import OTOSelectorView from '../views/OTOSelectorView'
import OTOAccessView from '../views/OTOAccessView'
import OTOOpenView from '../views/OTOOpenView'

//RENTAL VACWAY
import LockerSelectorRentalView from '../views/LockerSelectorRentalView'
import ZoneSelectorRentalView from '../views/ZoneSelectorRentalView'
import PhoneRentalView from '../views/PhoneRentalView'
import PaymentRentalView from '../views/PaymentRentalView'
import TicketRentalView from '../views/TicketRentalView'

//BAQUEIRA ONLY CUSTOM DESIGN
import PaymentBaqueiraView from '../views/PaymentBaqueiraView'
import PhoneBaqueiraView from '../views/PhoneBaqueiraView'
import TicketBaqueiraView from '../views/TicketBaqueiraView'
import LockerSelectorBaqueiraView from '../views/LockerSelectorBaqueiraView'
import ZoneSelectorBaqueiraView from '../views/ZoneSelectorBaqueiraView'
import PaymentBaqueiraError from '../views/PaymentBaqueiraError'

class App extends React.Component {
       render() {
              return (
                     <div>
                            <div className="container pt-3">
                                   <Switch>
                                          <Route path="/" exact
                                                 component={HomeView} />
                                          <Route path="/users" exact
                                                 component={UsersView} />
                                          <Route path="/users/add" exact
                                                 component={UserAddForm} />
                                          <Route path="/users/:number/edit"
                                                 component={UserEditForm} />
                                          <Route path="/users/:number"
                                                 component={UserDetailsView} />
                                          <Route path="/accessibilityView"
                                                 component={AccessibilityView} />
                                          <Route path="/paymentView"
                                                 component={PaymentView} />
                                          <Route path="/phoneView"
                                                 component={PhoneView} />
                                          <Route path="/ticketView"
                                                 component={TicketView} />
                                          <Route path="/lockerSelectorView"
                                                 component={LockerSelectorView} />
                                          <Route path="/zoneSelectorView"
                                                 component={ZoneSelectorView} />
                                          <Route path="/paymentError"
                                                 component={PaymentError} />


                                          <Route path="/otoSelectorView"
                                                 component={OTOSelectorView} />
                                          <Route path="/otoAccessView"
                                                 component={OTOAccessView} />
                                          <Route path="/otoOpenView"
                                                 component={OTOOpenView} />


                                          <Route path="/zoneSelectorRentalView"
                                                 component={ZoneSelectorRentalView} />
                                          <Route path="/lockerSelectorRentalView"
                                                 component={LockerSelectorRentalView} />
                                          <Route path="/phoneRentalView"
                                                 component={PhoneRentalView} />
                                          <Route path="/paymentRentalView"
                                                 component={PaymentRentalView} />
                                          <Route path="/ticketRentalView"
                                                 component={TicketRentalView} />


                                          <Route path="/paymentBaqueiraView"
                                                 component={PaymentBaqueiraView} />
                                          <Route path="/phoneBaqueiraView"
                                                 component={PhoneBaqueiraView} />
                                          <Route path="/ticketBaqueiraView"
                                                 component={TicketBaqueiraView} />
                                          <Route path="/lockerSelectorBaqueiraView"
                                                 component={LockerSelectorBaqueiraView} />
                                          <Route path="/zoneSelectorBaqueiraView"
                                                 component={ZoneSelectorBaqueiraView} />
                                          <Route path="/paymentBaqueiraError"
                                                 component={PaymentBaqueiraError} />


                                          <Route path="*"
                                                 component={NotFoundView} />
                                   </Switch>
                            </div>
                     </div>
              )
       }
}

export default App
